import WorkRecorderModel from '@/_models/WorkRecorderModel'
import { commonService } from '../../_services'

const initialState = {
  all: {
    items: [],
    stamp_rallies: [],
    work_recorders: [],
  },
  loading: false,
}

const deepCloneInitial = JSON.parse(JSON.stringify(initialState))

/* tslint:disable:variable-name */
export const analysis = {
  namespaced: true,
  state: deepCloneInitial,
  actions: {
    async getAllAnalysisWrapper(context: any, params: any = {}): Promise<void> {
      context.commit('GET_ALL_REQUEST', params.loading)

      return await commonService('api/v1/analysis/wrapper')
        .getAll(params)
        .then(resp => {
          context.commit('GET_ALL_SUCCESS', resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_ALL_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
    },
    async getAllAnalysisWrapNotStored(context: any, params: any = {}): Promise<void> {
      return await commonService('api/v1/analysis/wrapper')
        .getAll(params)
        .then(resp => {
          return resp.data
        })
        .catch(errorMsg => {
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
          return null
        })
    },
    async getAllStampRally(context: any, params: any = {}): Promise<void> {
      context.commit('GET_ALL_REQUEST')

      return await commonService('api/v1/analysis/stamprally')
        .getAll(params)
        .then(resp => {
          context.commit('GET_ALL_STAMP_RALLY_SUCCESS', resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_ALL_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
    },
    async getAllWorkRecorder(context: any, params: any = {}): Promise<void> {
      context.commit('GET_ALL_REQUEST')
      return await commonService('api/v1/analysis/workrecorder')
        .getAll(params)
        .then(resp => {
          context.commit('GET_ALL_WORK_RECORDER_SUCCESS', resp.data)
        })
        .catch(errorMsg => {
          context.commit('GET_ALL_FAILURE')
          context.dispatch('common/setFlashMessage', { error: [errorMsg] }, { root: true })
        })
    },
  },
  mutations: {
    GET_ALL_REQUEST(state: any, loading: boolean = true) {
      state.loading = loading
    },
    GET_ALL_SUCCESS(state: any, allItems: any[]) {
      state.all = { ...state.all, items: allItems }
      state.loading = false
    },
    GET_ALL_STAMP_RALLY_SUCCESS(state: any, allItems: any[]) {
      state.all.stamp_rallies = allItems
      state.loading = false
    },
    GET_ALL_WORK_RECORDER_SUCCESS(state: any, allItems: WorkRecorderModel[]) {
      state.all.work_recorders = allItems
      state.loading = false
    },
    GET_ALL_FAILURE(state: any) {
      state.all = { items: [] }
      state.loading = false
    },
    RESET_STATE(state: any) {
      const init = JSON.parse(JSON.stringify(initialState))
      Object.keys(init).forEach(key => {
        state[key] = init[key]
      })
    },
  },
  getters: {},
}
